/** SplitContainer registration: parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseSplitContainer } from './parser';
const splitContainerRegistration = {
    typeName: 'SplitContainer',
    parser: parseSplitContainer,
};
nodeRegistry.register(splitContainerRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map